export default {
  fr: {
    title: 'Nos captains soutiennent déjà ✊',
  },
  en: {
    title: 'Our captains already support it ✊',
  },
  'pt-br': {
    title: 'Nossos capitães já o apóiam ✊',
  },
  es: {
    title: 'Nuestros capitanes ya lo apoyan ✊',
  },
  de: {
    title: 'Unsere Kapitäne unterstützen es bereits ✊',
  },
} as const
